import React from 'react';
import ReactDOM from 'react-dom';
import DownloadManuals from './download-manuals';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('download-manuals-react-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
                <DownloadManuals />
        </React.StrictMode>,
        $root
    );
};

init();